export enum SlaTimeUnitEnum {
  hours = 'HOURS',
  days = 'DAYS',
}
